<!-- src/components/notifications/TermoNotification.vue -->
<template>
  <transition name="modal">
    <div v-if="show" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div class="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-xl max-w-lg w-full mx-4">
        <h2 class="text-xl font-bold mb-4 text-gray-900 dark:text-white">Termo de Aceite de Notificações</h2>
        <p class="text-gray-700 dark:text-gray-300 mb-6 text-sm leading-relaxed">
          Ao habilitar as notificações, o colaborador declara estar ciente de que poderá receber comunicações fora do horário de expediente, inclusive finais de semana e feriados.
          Essas notificações têm caráter informativo, como atualizações de sistemas, alertas importantes, comunicações internas e eventos relevantes.
          Ao aceitar, o colaborador autoriza o envio dessas mensagens e poderá desabilitar as notificações a qualquer momento.
        </p>
        <div class="flex justify-end space-x-4">
          <button @click="$emit('cancelar')" class="px-4 py-2 bg-gray-200 dark:bg-gray-700 rounded-md text-gray-800 dark:text-gray-200 hover:bg-gray-300 dark:hover:bg-gray-600 flex items-center">
            Cancelar
            <span class="ml-2 text-xs text-gray-600 dark:text-gray-300">({{ secondsLeft }}s)</span>
          </button>
          <button @click="$emit('confirmar')" class="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700">
            Aceitar e Habilitar
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>
  
<script setup>
import { defineProps, watch, defineEmits, onBeforeUnmount, ref } from 'vue';

const props = defineProps({
  show: {
    type: Boolean,
    required: true
  }
});

let timeoutId = null;
let intervalId = null;
const secondsLeft = ref(10);

const emit = defineEmits(['cancelar', 'confirmar']);

const startTimer = () => {
  clearTimeout(timeoutId);
  clearInterval(intervalId);
  secondsLeft.value = 10;
  intervalId = setInterval(() => {
    if (secondsLeft.value > 0) {
      secondsLeft.value -= 1;
    }
  }, 1000);
  timeoutId = setTimeout(() => {
    emit('cancelar');
  }, 10000);
};

const clearTimer = () => {
  clearTimeout(timeoutId);
  clearInterval(intervalId);
  secondsLeft.value = 10;
};

watch(
  () => props.show,
  (val) => {
    if (val) {
      startTimer();
    } else {
      clearTimer();
    }
  }
);

onBeforeUnmount(() => {
  clearTimer();
});
</script>
  
  <style scoped>
  .modal-enter-active,
  .modal-leave-active {
    transition: opacity 0.3s ease;
  }
  .modal-enter-from,
  .modal-leave-to {
    opacity: 0;
  }
  </style>
  